<div class="container">
  <span><button (click)="closeSnackBar()" class="delete" style="float: right"></button></span>
  <p>Es ist ein Fehler aufgetreten.</p>
  <p>Die Seite <a (click)="reload()" style="color: black; text-decoration: underline">neu laden</a> oder
    <a  (click)="closeSnackBar()" routerLink="/home" style="color: black; text-decoration: underline">zurück zum Dashboard</a></p>
</div>
